

export const SidebarData = [
  {
    menuValue: 'Dashboard',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-dashboard",
    icon: "la la-dashcube",
    code: "dashboard"
  },
  {
    menuValue: 'Employee Statistics',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-statistics",
    icon: "la la-chart-bar",
    code: "employee_statistics"
  },
  {
    menuValue: 'Employees',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employees",
    icon: "la la-user",
    code: "employee"
  },
  {
    menuValue: 'Holidays',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/holidays",
    icon: "la la-calendar-o",
    code: "holiday"
  },
  {
    menuValue: 'Leaves',
    hasSubRoute: true,
    showSubRoute: false,
    // route: "/leaves-employee",
    icon: "la la-calendar-check-o",
    code: "leave",
    subMenus: [
      {
        menuValue: 'Leave List',
        route: "/leaves-employee",
        code: "leave",

      },
      {
        menuValue: 'Leave View',
        route: "/leave-calendar",
        code: "leave",

      },
      {
        menuValue: 'Leave Planner',
        route: "/leave-planner",
        code: "leave",

      },
    ]
  },
  {
    menuValue: 'Company Directory',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/company-directory",
    icon: "la la-user-shield",
    code: "company_directory",
  },
  {
    menuValue: 'Expenses',
    hasSubRoute: false,
    showSubRoute: false,
    icon: "la la-wallet",
    route: "/expenses",
    code: "expense",
  
  },
  {
    menuValue: 'Payroll',
    hasSubRoute: true,
    showSubRoute: false,
    icon: "la la-money",
    code: "payroll",
    subMenus: [
      {
        menuValue: 'Employee Salary',
        route: "/salary",
        code: "payroll",

      },
    
      {
        menuValue: 'Payroll Items',
        route: "/salary/payroll",
        code: "payroll",

      },
    ]
  },

{
  menuValue: 'Documents',
  hasSubRoute: true,
  showSubRoute: false,
  icon: "la la-file-pdf-o",
  // route: "/documents",
  code: "document",
  subMenus: [
    {
      menuValue: 'User Documents',
      route: "/documents",
        code: "document_employee",

    },
  
    {
      menuValue: 'Store Documents',
      route: "/documents/store",
      code: "document_store",

    },
  ]
},
{
  menuValue: 'Assets',
  hasSubRoute: false,
  showSubRoute: false,
  route: "/assets",
  icon: "la la-boxes",
  code: "asset",
},
{
  menuValue: 'Jobs',
  hasSubRoute: true,
  showSubRoute: false,
  // route: "/manage-jobs",
  code: "job",
  icon: "la la-briefcase",
  subMenus: [
    {
      menuValue: 'Manage Jobs',
      route: "/manage-jobs",
      code: "job_hiring",

    },
    {
      menuValue: 'Manage Resumes',
      route: "/manage-resumes",
      code: "job_hiring",

    },
    {
      menuValue: 'Employee referrals',
      route: "/employee-referrals",
      code: "job_referral",

    },
    {
      menuValue: 'Job Drive Slots',
      route: "/job-drive-slots",
      code: "job_drive_slot",
    },
    {
      menuValue: 'Job Drive Invitations',
      route: "/job-drive-dashboard",
      code: "job_drive_invitation",
    },
    {
      menuValue: 'Scan Invitation',
      route: "/job-drive-scan",
      code: "job_drive_scan_invitation",
    },
    {
      menuValue: 'Job Drive Attendance Logs',
      route: "/job-drive-attendance",
      code: "job_drive_attendance",
    },
  ]
},
{
  menuValue: 'Uniform Management',
  hasSubRoute: true,
  showSubRoute: false,
  // Parent is gated on `uniform_management`. Individual submenus are also
  // gated on their own codes (uniform_user, uniform_masters, uniform_stock, etc.).
  code: "uniform_management",
  icon: "la la-shirtsinbulk",
  subMenus: [
    {
      menuValue: 'My Uniforms',
      route: "/uniform-management/my-uniforms",
      code: "uniform_user",
    },
    {
      menuValue: 'Masters',
      route: "/uniform-management",
      code: "uniform_masters",
    },
    {
      menuValue: 'Purchase Orders',
      route: "/uniform-management/purchase-orders",
      code: "uniform_stock",
    },
    {
      menuValue: 'Transfers',
      route: "/uniform-management/transfers",
      code: "uniform_stock",
    },
    {
      menuValue: 'Stock Takes',
      route: "/uniform-management/stock-take",
      code: "uniform_stock",
    },
    {
      menuValue: 'Issuance',
      route: "/uniform-management/issuance",
      code: "uniform_assign",
    },
    {
      menuValue: 'Bulk Issuance',
      route: "/uniform-management/bulk-issuance",
      code: "uniform_assign",
    },
    {
      menuValue: 'Rejection Review',
      route: "/uniform-management/rejection-review",
      code: "uniform_assign",
    },
    {
      menuValue: 'Reports',
      route: "/uniform-management/reports",
      code: "uniform_reports",
    },
  ]
},

{
  menuValue: 'Resignation',
  hasSubRoute: false,
  showSubRoute: false,
  route: "/resignations",
  icon: "las la-user-times",
  code: "resignation",
},


{
  menuValue: 'Discount',
  hasSubRoute: false,
  showSubRoute: false,
  route: "https://discount.nandosess.ae",
  icon: "las la-percentage",
  code: "staff_discount",
},

{
  menuValue: 'Organization Chart',
  hasSubRoute: false,
  showSubRoute: false,
  route: "/org-chart",
  icon: "las la-sitemap",
  code: "org_chart",
},

{
  menuValue: 'Others',
  hasSubRoute: true,
  showSubRoute: false,
  icon: "la la-archive",
  code: "others",

  subMenus: [
    {
      menuValue: 'Designations',
      route: "/designations",
      code: "designation",

    },
    {
      menuValue: 'Departments',
      route: "/departments",
      code: "department",
    },
    {
      menuValue: 'Grades',
      route: "/grades",
      code: "grades",

    },

   
  ]
},

          {
            menuValue: 'Settings',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/settings",
            icon: "la la-cog",
            code: "role_permission",
            subMenus: [
             
              {
                menuValue: 'Roles & Permissions',
                route: "/roles-permissions",
                code: "role_permission",
              },

              {
                menuValue: 'Request Approver',
                route: "/request-approver",
                code: "role_permission",
              },
              {
                menuValue: 'Sync Data',
                route: "/sync-data",
                code: "data_sync",
              },
             
            ]
          },


   
  ];
  